import TalentSignupPage from './TalentSignup'
import TalentSignupWithoutReferralPage from './SignupWithoutReferral'
import {useNavigate, useParams} from "react-router-dom";
import React from "react";

export default class SignupViaInvite extends TalentSignupPage
{
    static path = '/signup/invite/talent/:token';

   	/**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props)
    {
		super(props);

        let user = laravel.registering_user
            || {};

		this.state = {
			...this.state,
			model: {...user},
		};
	}

    /**
     * @returns {String | Array}
     */
    static formViewTitle()
    {
    	if (!TB.isObject(laravel.registering_user)) {
            return TB.tryTrans(
                'auth.signup.talent.invalid_invite_title'
            );
    	}

        return super.formViewTitle();
    }

    /**
     * @returns {String | Array}
     */
    static formViewSubtitle()
    {
        if (!TB.isObject(laravel.registering_user)) {
            return TB.tryTrans(
                'auth.signup.talent.invalid_invite_subtitle'
            );
        }

        return super.formViewTitle();
    }

    // static formViewLinks()
    // {
    //     if (!TB.isObject(laravel.registering_user)) {
    //         return [
    //             // {
    //             //     title: 'auth.signup.talent.invalid_invite_subtitle_signup_link',
    //             //     path: '/signup/talent',
    //             // },
    //             {
    //                 title: 'auth.signup.talent.invalid_invite_subtitle_login_link',
    //                 path: '/login',
    //             },
    //         ];
    //     }

    //     return this.FormViewLinks;
    // }

    /**
     * @returns {String}
     */
    formPost()
    {
    	if (!TB.isObject(laravel.registering_user)) {
    		return;
    	}

        return undefined;
        // return undefined;
    }

    /**
     * @returns {String | Boolean | Object}
     */
    formSubmit()
    {
    	if (!TB.isObject(laravel.registering_user)) {
            return TB.tryTrans(
                'auth.signup.talent.invalid_invite_submit_button'
            );
    	}

    	return super.formSubmit();
    }

    /**
     * @returns {Object | Array}
     */
    formFields()
    {
    	if (!TB.isObject(laravel.registering_user)) {
    		return {
                title: this.constructor.renderTitle(),
            };
    	}

        return super.formFields();
    }

    /**
     * Maps form input data to form submit model
     * Appends token to form data from url route parameter
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model)
    {
        if (!TB.isObject(laravel.registering_user)) {
            this.props.navigate(
                TalentSignupWithoutReferralPage.path
            );

            return {};
        }

        model.token = this.props.token;

        return model;
    }
}

const TalentSignupViaInvite = (props) => {
    const {token} = useParams();
    const navigate = useNavigate();

    return (
        <SignupViaInvite token={token} navigate={navigate}/>
    )
}

export {
    TalentSignupViaInvite
}